import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/CartContext";
import Navbar from "@/components/Navbar";
import HomePage from "@/pages/HomePage";
import MenuPage from "@/pages/MenuPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmation from "@/pages/OrderConfirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background font-body">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/confirmation" element={<OrderConfirmation />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <footer className="border-t border-border bg-[#78350F] text-[#FED7AA] mt-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                  <h3 className="font-heading text-2xl text-white mb-3">Meals-O-Meals</h3>
                  <p className="text-sm leading-relaxed opacity-80">
                    Bringing the flavors of India to your doorstep. The perfect catering solution for your next home party or get-together!
                  </p>
                </div>
                <div>
                  <h4 className="font-body font-semibold text-white mb-3 text-sm tracking-widest uppercase">Contact</h4>
                  <div className="space-y-2 text-sm opacity-80">
                    <p>(609)-288-0605</p>
                    <p>(609)-933-7076</p>
                    <p>mealsomeals@gmail.com</p>
                    <p>Zip Code: 08053</p>
                  </div>
                </div>
                <div>
                  <h4 className="font-body font-semibold text-white mb-3 text-sm tracking-widest uppercase">Info</h4>
                  <div className="space-y-2 text-sm opacity-80">
                    <p>Small Tray serves ~10 people</p>
                    <p>Medium Tray serves ~20 people</p>
                    <p>Med-Large Tray serves ~25-30 people</p>
                    <p>Large Tray serves ~35-40 people</p>
                    <p className="pt-2 text-xs italic">All orders must be booked at least one week in advance. Delivery charges applicable.</p>
                  </div>
                </div>
              </div>
              <div className="mt-10 pt-6 border-t border-white/10 text-center text-xs opacity-60">
                <p>Meals-O-Meals (M.O.M) - Traditional Indian Cuisine for Your Special Events</p>
              </div>
            </div>
          </footer>
        </div>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
